import { Button, Modal } from "@findemdev/maui";

interface IShareListModalProps {
  open: boolean;
  isLoading: boolean;
  onShareAndContinue: () => void;
  onClose: () => void;
}

const ShareListModal = ({
  open,
  isLoading,
  onShareAndContinue,
  onClose,
}: IShareListModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Share this list to view network contacts"
      footer={[
        <Button key="close" onClick={onClose} disabled={isLoading}>
          {isLoading ? "Cancel" : "Close"}
        </Button>,
        <Button
          key="share"
          type="primary"
          onClick={onShareAndContinue}
          loading={isLoading}
        >
          Share and continue
        </Button>,
      ]}
    >
      To see contacts and intro opportunities for these companies, this list
      needs to be shared with your team.
    </Modal>
  );
};

export default ShareListModal;
